import { render, staticRenderFns } from "./Carrito.vue?vue&type=template&id=e09212c8&"
import script from "./Carrito.vue?vue&type=script&lang=js&"
export * from "./Carrito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports